import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import companyService from "../../services/companyService";
import darkWebService from "../../services/darkWebService";
import { cardStyle } from "../../shared/Theme";
import BreachLineGraph from "../DarkWeb/BreachLineGraph";

const CardDarkWebExposure = (props) => {

	const navigate = useNavigate();
	
	let [ fromDate, setFromDate ] = useState(darkWebService.getMinBreachDate());
	let [ toDate, setToDate ] = useState(darkWebService.getMaxBreachDate());
	let [ breaches, setBreaches ] = useState(darkWebService.BreachesForDates(fromDate, toDate));
	
	useEffect(() => {
		companyService.onSelectCompany(() => {
			const newFromDate = darkWebService.getMinBreachDate();
			const newToDate = darkWebService.getMaxBreachDate();
			
			setBreaches(darkWebService.BreachesForDates(newFromDate, newToDate));
			setFromDate(newFromDate);
			setToDate(newToDate);
		});
	}, []);
	
	const handleTitleClick = () => {
		navigate("/darkweb");
	};
	
	return (
		<React.Fragment>
			<Stack
				direction="column"
				onClick={handleTitleClick}
				sx={{ ...cardStyle, width: "28em", height: "16em", '&:hover': { cursor: "pointer" } }}
			>
				<Typography
					variant="h5"
					sx={{
						width: "100%",
						textAlign: "center",
						marginTop: "1em",
						cursor: "pointer",
						fontWeight: "bold"
					}}
					onClick={handleTitleClick}
				>
					Dark Web Exposure
				</Typography>
				<Box sx={{ width: "70%", margin: "auto" }}>
					<BreachLineGraph
						breaches={breaches}
						fromDate={fromDate}
						toDate={toDate}
					/>
				</Box>
			</Stack>
		</React.Fragment>
	);

}

export default CardDarkWebExposure;